import $ from 'jquery';
import 'pickadate/lib/picker.date';
import {init_table_check_all_box, disp_xhr_error, resize_iframe}  from './ui_tweak.js';
import i18n from '../jssrc/i18n_js_with_locales';

function init_summernote(){
    $('textarea.summernote').summernote({
	disableDragAndDrop: true,
	toolbar: [
	    ['style', ['style']],
	    ['font', ['bold', 'underline', 'clear']],
	    ['fontname', ['fontname']],
	    ['color', ['color']],
	    ['para', ['ul', 'ol', 'paragraph']],
	    ['table', ['table']],
	    ['insert', ['link', 'picture', 'video']],
	    ['view', ['fullscreen', 'codeview', 'help']],
	],
	// Constrain style picker so users can't emit a page-level <h1> from
	// inside a JD body — the surrounding page already owns <h1>, and a
	// second one confuses screen readers and section outlines. Also drop
	// h2 (reserved for section headers on the page shell); h3/h4 are the
	// natural sizes for JD internal structure.
	styleTags: ['p', 'blockquote', 'h3', 'h4', 'h5', 'h6'],
	minHeight: 240,
    });
}

function get_default_pickadate_options(){
    var options = {
	format: 'yyyy-mm-dd',
	editable: true
    };
    if (i18n.locale === "zh-CN"){
	Object.assign(options, {
	    monthsFull: [ '一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月' ],
	    monthsShort: [ '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二' ],
	    weekdaysFull: [ '星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六' ],
	    weekdaysShort: [ '日', '一', '二', '三', '四', '五', '六' ],
	    today: '今天',
	    clear: '清除',
	    close: '关闭',
	    firstDay: 1,
	});
    }
    return options;
}

function update_recruiter_table(html_resp){
    $('#recruiters-info').html(html_resp);
}


function init_recruiter_info_table(){
    $('#recruiters-info').each(function(){
	$.get(window.location.pathname+'/assignments').done(function(resp){ update_recruiter_table(resp); });
    });

    $('#recruiters-info')
	.on('ajax:success', 'a.delete-link', function(e){
	    const [, , xhr] = e.detail;
	    update_recruiter_table(xhr.responseText); })
	.on('ajax:error',   'a.delete-link', function(e){
	    const [, , xhr] = e.detail;
	    alert(xhr.responseText);}
	   );

    $(document).on('ajax:success', '#assignment-wrapper form', function(event) {
	const [, , xhr] = event.detail;
	update_recruiter_table(xhr.responseText);
	$.jqmodal.close();
    });
    $(document).on('ajax:error', '#assignment-wrapper form', function(event) {
	const [, , xhr] = event.detail;
	disp_xhr_error(this, xhr); } );
}

function bind_event_for_ajax_add_applicant(){
    $('#new_applicant')
	 .on("ajax:success", function(e){
	     $('#applicant-input-body').hide();
	     $('#application-result-dialog').modal('show');
	 })
	 .on("ajax:error", function(e){
	     const [, , xhr] = e.detail;
	     disp_xhr_error(this, xhr );
	 });
}


function init_email_template_fields(){
    var activeInput = null;
    var caretPos = 0;
    $('.email-template .allow-vars').on('focus', function(){
    	activeInput = $(this);
    });
    $('.email-template .not-allow-vars').on('focus',function(){
    	activeInput = null;
    });
    $('.email-template .allow-vars').blur(function(){
    	caretPos = this.selectionStart;
    });

    $('.email-template #vars-list li a').on('click', function(e){
	e.preventDefault();
	if (activeInput != null){
	    var key = $(this).data("key")
	    var old_v = activeInput.val();
	    activeInput.get(0).setSelectionRange(0,old_v.length);
	    activeInput.val(old_v.substring(0,caretPos) + key + ' ' +  old_v.substring(caretPos));
	    activeInput.get(0).setSelectionRange(caretPos, caretPos + key.length);
	    activeInput.focus();
	}
    });
}

function init_select_month(){
    $('#month-slider').slider().on('slide', function(ev){
        ajax_set_month(ev.value);
    });
    var page_data = $('.ruby-to-js').data('purchase');
    if (page_data) ajax_set_month(page_data.subscription_months);
}

function ajax_set_month(month_num){
    var page_data = $('.ruby-to-js').data('purchase');
    $.ajax({url: '/purchases/verify',
            type: 'POST',
            dataType: 'json',
            data: { subscription_type: page_data.subscription_type,
                    subscription_months: month_num },
            success: function(data) {
                if (data.order_validity == true){
                    $('#purchase_subscription_months').val(month_num);
                    $('.total-amount #total').text(data.final_fee);
                    $('.total-amount #save').text(data.saved_fee);
                    $('.total-amount #discount-rate').text(data.discount_off_rate);
                    $('.total-amount #expire-date').text(data.expire_date);

                }else {
                    $('#select-month-alert-msg p').text(data.error_msg);
                    $('#select-month-alert-msg').show();
                }
            }});
}

function init_iframe_load_event(){
    $('iframe').on('load', function() {
	resize_iframe(this);
    });
    $('iframe').trigger('load');
}

function init_opening_op_buttons(){
    $('#opening-op-btns .operative').click(function(e){
	var opening = $('.ruby-to-js').data('inactive-reminder');
	if (!opening.being_active) {
	    e.preventDefault();
	    alert(opening.reminder);
	    return false;
	}
    });
}

$(document).ready(function(){
    init_summernote();
    init_recruiter_info_table();           // opening show.html.erb
    bind_event_for_ajax_add_applicant();   //applicant new.html.erb
    init_email_template_fields();

    $('.datepicker').pickadate( get_default_pickadate_options() );
    if ($.fn.carousel) $('#carousel-casts').carousel();  //screenshots.html.erb (BS5 uses native data-bs-ride)
    $('form#new_email_input input[type="text"]').focus();  //invitations new.html.erb

    init_select_month();
    init_table_check_all_box();
    init_opening_op_buttons();
    init_iframe_load_event();
});
